import api from "./api";

export async function getPromos(page = 1, filters = {}) {
    const params = { page, ...filters };
    const res = await api.get("/admin/promotions", { params });
    return res.data.data; 
}

export async function getPromo(id) {
    const res = await api.get(`/admin/promotions/${id}`);
    return res.data.data;
}

export async function createPromo(payload) {
    const res = await api.post("admin/promotions", payload);
    return res.data.data;
}